<template>
    <div class="ranking">
        <comHead :headObj="headObj"></comHead>
        <div class="rank">
            <div class="rank-saiji">
                <div class="rank-saiji-title">
                    <span>当前赛季前20名</span>
                </div>
                <div class="rank-saiji-body">
                    <div class="rank-saiji-body-title rank-saiji-body-lie">
                        <span>段位排名</span>
                        <span>指挥官</span>
                        <span>段位星</span>
                    </div>
                    <ul class="rank-saiji-body-ul" v-if="ranksaijiList.star_rank">
                        <li class="rank-saiji-body-lie" v-for="(item,index) in ranksaijiList.star_rank.slice(0,20)" :key="index">
                            <span>
                               <span :class="{orderIndex : index<3}"> {{index+1}}</span>
                            </span>
                            <span>{{item.username}}</span>
                            <span>
                                <span>{{getStarLevel(item.star_score)}}</span>
                                <span style="margin-left:5px;color:#13227a;font-weight:600">({{item.star_score}}
                                    <img style="width:19px" src="./../../assets/star.png" alt="">)
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import comHead from './../../components/header.vue'
import { get } from './../../utils/httpService'
export default {
  data () {
    return {
      headObj: {
        backgroundc: '#fff',
        color: '#222',
        title: '赛季天梯'
      },
      ranksaijiList: [],
      starConfig: [
        {
          level: 10,
          name: '司令',
          star: 3000
        },
        {
          level: 9,
          name: '军长',
          star: 2300
        },
        {
          level: 8,
          name: '师长',
          star: 1700
        },
        {
          level: 7,
          name: '旅长',
          star: 1200
        },
        {
          level: 6,
          name: '团长',
          star: 800
        },
        {
          level: 5,
          name: '营长',
          star: 500
        },
        {
          level: 4,
          name: '连长',
          star: 300
        },
        {
          level: 3,
          name: '排长',
          star: 150
        },
        {
          level: 2,
          name: '班长',
          star: 50
        },
        {
          level: 1,
          name: '新兵',
          star: 0
        }
      ]
    }
  },
  components: {
    comHead
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        this.ranksaijiList = await get('/api/shop/ranks')
        console.log('Fetched data:', this.list)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    getStarLevel (starNum) {
      console.log('lll', starNum)
      for (let i in this.starConfig) {
        if (starNum >= this.starConfig[i].star) {
          return this.starConfig[i].name
        }
      }
    }
  }
}
</script>

<style scoped>
    .rank{width: 100%;height: auto;display: flex;flex-direction: column;align-items: center;margin-top: 0.2rem;margin-bottom: 30px;}
    .rank-saiji{width: 94%;height: auto;box-shadow: 0 1px 10px hsl(0deg 0% 0% / 0.075);
    /* border-bottom-left-radius: 38px;border-top-right-radius: 38px; */
    }
    .rank-saiji-title{font-size: 0.3rem;background: black;text-align: center;color: #fff;padding: 0.15rem 0;
    /* border-top-right-radius: 38px; */
    }
    .rank-saiji-body{margin-top:0.3rem}
    .rank-saiji-body-lie{display: flex;justify-content: space-around;width: 100%;}
    .rank-saiji-body-lie > span{display: inline-block;width: 33%;text-align: center;}
    .rank-saiji-body-title{font-size: 0.3rem;}
    .rank-saiji-body-ul{font-size: 0.28rem;margin-top: 0.2rem;}
    /* .rank-saiji-body-ul li {margin-top: 0.2rem;} */
    .rank-saiji-body-ul li span{height: 0.5rem;display: flex;align-items: center;justify-content: center;border-bottom: 1px solid #dee;}
    .orderIndex {background: #000;width: 0.3rem !important;height: 0.3rem !important;color: #fff;border-radius: 50%;}
</style>



// WEBPACK FOOTER //
// src/view/ranking/index.vue